import { createContext, useContext } from "react";

const EditModeContext = createContext(false),

  useEditMode = (): boolean => useContext(EditModeContext);

export { EditModeContext, useEditMode };
